module.exports = __webpack_public_path__ + "static/media/camera-offline.244d4bf1.png";